import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';

export function RequiredFormReason({ actions }: { actions?: ButtonPropsWithLabel[] }) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.formsRequired.title')}
      message={t('blockingReasons.formsRequired.message')}
      actions={actions}
    />
  );
}
